import { Text } from '@mantine/core';
export function WrittenError(): JSX.Element {
  return <Text>There was an error uploading your written review</Text>;
}
